import { graphql } from "@opensea/graphql"
import { ProfileBioFragment } from "./ProfileBio.fragment"
import { ProfileHeaderMetadataChipsFragment } from "./ProfileHeaderMetadataChips.fragment"
import { ProfileInfoFragment } from "./ProfileInfo.fragment"

export const ProfileHeaderFullContentFragment = graphql(
  `
    fragment ProfileHeaderFullContent on Profile {
      address
      ...ProfileInfo
      ...ProfileHeaderMetadataChips
      ...ProfileBio
    }
  `,
  [ProfileInfoFragment, ProfileHeaderMetadataChipsFragment, ProfileBioFragment],
)
